import React from "react";

export const VolumeIntensityIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill={color}
  >
    <g
      id="vuesax_linear_chart"
      data-name="vuesax/linear/chart"
      transform="translate(-108 -252)"
    >
      <g id="chart" transform="translate(108 252)">
        <path
          id="Vector"
          d="M0,0V4.305"
          transform="translate(9.333 16.646)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V8.988"
          transform="translate(16 11.645)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0V4.305"
          transform="translate(22.667 16.646)"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M9.316,26.618H17.3c6.655,0,9.316-2.662,9.316-9.316V9.316C26.618,2.662,23.956,0,17.3,0H9.316C2.662,0,0,2.662,0,9.316V17.3C0,23.956,2.662,26.618,9.316,26.618Z"
          transform="translate(2.691 2.691)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          stroke={color}
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const BaselineAndRelativeIntensityIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_activity"
      data-name="vuesax/linear/activity"
      transform="translate(-364 -188)"
    >
      <g id="activity" transform="translate(364 188)">
        <path
          id="Vector"
          d="M9.342,26.691h8.007c6.673,0,9.342-2.669,9.342-9.342V9.342C26.691,2.669,24.022,0,17.349,0H9.342C2.669,0,0,2.669,0,9.342v8.007C0,24.022,2.669,26.691,9.342,26.691Z"
          transform="translate(2.655 2.655)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,6.61l3.159-4.1A1.332,1.332,0,0,1,5.03,2.27L7.459,4.181a1.343,1.343,0,0,0,1.871-.226L12.4,0"
          transform="translate(9.802 12.695)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const OverUnderBaselineIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="31.854"
    viewBox="0 0 32 31.854"
  >
    <g
      id="vuesax_linear_status-up"
      data-name="vuesax/linear/status-up"
      transform="translate(-236 -252)"
    >
      <g id="status-up" transform="translate(236 252)">
        <path
          id="Vector"
          d="M0,2.747V0"
          transform="translate(9.173 21.342)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,5.495V0"
          transform="translate(16 18.595)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,8.256V0"
          transform="translate(22.827 15.834)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M13.591,0l-.611.717A25.062,25.062,0,0,1,0,8.733"
          transform="translate(9.204 7.765)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H3.889V3.876"
          transform="translate(18.932 7.765)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M9.342,26.545h8.007c6.673,0,9.342-2.655,9.342-9.291V9.291C26.691,2.655,24.022,0,17.349,0H9.342C2.669,0,0,2.655,0,9.291v7.964C0,23.891,2.669,26.545,9.342,26.545Z"
          transform="translate(2.655 2.655)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M0,0H32V31.854H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const VolumeSplitCoreLiftIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_ruler"
      data-name="vuesax/linear/ruler"
      transform="translate(-618 -190)"
    >
      <g id="ruler" transform="translate(618 190)">
        <path
          id="Vector"
          d="M4,13.273H22.687q4,0,4-3.982V3.982q0-3.982-4-3.982H4Q0,0,0,3.982V9.291Q0,13.273,4,13.273Z"
          transform="translate(2.655 9.364)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0V6.636"
          transform="translate(24 9.345)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0V5.309"
          transform="translate(8 9.342)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M.066,0,0,6.636"
          transform="translate(13.333 9.345)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0V3.982"
          transform="translate(18.667 9.339)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const PersonalRecordTableIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_personalcard"
      data-name="vuesax/linear/personalcard"
      transform="translate(-172 -252)"
    >
      <g id="personalcard" transform="translate(172 252)">
        <path
          id="Vector"
          d="M20,24H6.667C1.333,24,0,22.667,0,17.333V6.667C0,1.333,1.333,0,6.667,0H20c5.333,0,6.667,1.333,6.667,6.667V17.333C26.667,22.667,25.333,24,20,24Z"
          transform="translate(2.667 4)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H6.667"
          transform="translate(18.667 10.667)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H5.333"
          transform="translate(20 16)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H2.667"
          transform="translate(22.667 21.333)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M4.827,2.413A2.413,2.413,0,1,1,2.413,0,2.413,2.413,0,0,1,4.827,2.413Z"
          transform="translate(8.92 10.227)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M9.333,3.677A4.027,4.027,0,0,0,5.68.05a10.293,10.293,0,0,0-2.027,0A4.039,4.039,0,0,0,0,3.677"
          transform="translate(6.667 18.097)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const NumberLiftsIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_task-square"
      data-name="vuesax/linear/task-square"
      transform="translate(-492 -316)"
    >
      <g id="task-square" transform="translate(492 316)">
        <path
          id="Vector"
          d="M0,0H7"
          transform="translate(16.493 11.84)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,2,1,3,4,0"
          transform="translate(8.507 9.84)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H7"
          transform="translate(16.493 21.173)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,2,1,3,4,0"
          transform="translate(8.507 19.173)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M9.333,26.667h8c6.667,0,9.333-2.667,9.333-9.333v-8C26.667,2.667,24,0,17.333,0h-8C2.667,0,0,2.667,0,9.333v8C0,24,2.667,26.667,9.333,26.667Z"
          transform="translate(2.667 2.667)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const PrimarySecondaryVolumeSplitIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_signpost"
      data-name="vuesax/linear/signpost"
      transform="translate(-300 -700)"
    >
      <g id="signpost" transform="translate(300 700)">
        <path
          id="Vector"
          d="M16.32,0H5.271A2.4,2.4,0,0,0,3.812.5L.883,2.827a2.3,2.3,0,0,0,0,3.623l2.93,2.323a2.342,2.342,0,0,0,1.458.5H16.32a2.326,2.326,0,0,0,2.341-2.323V2.309A2.323,2.323,0,0,0,16.32,0Z"
          transform="translate(6.663 2.655)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M2.341,0H13.39a2.4,2.4,0,0,1,1.458.5l2.93,2.323a2.3,2.3,0,0,1,0,3.623l-2.93,2.323a2.342,2.342,0,0,1-1.458.5H2.341A2.326,2.326,0,0,1,0,6.955V2.309A2.323,2.323,0,0,1,2.341,0Z"
          transform="translate(6.703 16.03)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,3.982V0"
          transform="translate(16 12.008)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,3.982V0"
          transform="translate(16 25.364)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,0H7.964"
          transform="translate(12.018 29.345)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const RepMaxIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_chart-2"
      data-name="vuesax/linear/chart-2"
      transform="translate(-236 -188)"
    >
      <g id="chart-2" transform="translate(236 188)">
        <path
          id="Vector"
          d="M9.342,26.691h8.007c6.673,0,9.342-2.669,9.342-9.342V9.342C26.691,2.669,24.022,0,17.349,0H9.342C2.669,0,0,2.669,0,9.342v8.007C0,24.022,2.669,26.691,9.342,26.691Z"
          transform="translate(2.655 2.655)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M2.655,17.4a2.674,2.674,0,0,0,2.655-2.677V2.677A2.674,2.674,0,0,0,2.655,0,2.674,2.674,0,0,0,0,2.677V14.723A2.665,2.665,0,0,0,2.655,17.4Z"
          transform="translate(18.016 7.3)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M2.655,9.955A2.662,2.662,0,0,0,5.309,7.3V2.655A2.655,2.655,0,0,0,0,2.655V7.3A2.654,2.654,0,0,0,2.655,9.955Z"
          transform="translate(8.675 14.697)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
export const RPECustomIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g
      id="vuesax_linear_setting-3"
      data-name="vuesax/linear/setting-3"
      transform="translate(-364 -188)"
    >
      <g id="setting-3" transform="translate(364 188)">
        <path
          id="Vector"
          d="M9.342,26.691h8.007c6.673,0,9.342-2.669,9.342-9.342V9.342C26.691,2.669,24.022,0,17.349,0H9.342C2.669,0,0,2.669,0,9.342v8.007C0,24.022,2.669,26.691,9.342,26.691Z"
          transform="translate(2.655 2.655)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,5.176V0"
          transform="translate(20.76 19.484)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,2.588V0"
          transform="translate(20.76 7.336)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M6.9,3.451A3.451,3.451,0,1,1,3.451,0,3.451,3.451,0,0,1,6.9,3.451Z"
          transform="translate(17.315 9.946)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,2.588V0"
          transform="translate(11.24 22.076)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,5.176V0"
          transform="translate(11.24 7.34)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M6.9,3.451A3.451,3.451,0,1,1,3.451,0,3.451,3.451,0,0,1,6.9,3.451Z"
          transform="translate(7.783 15.152)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
        />
        <path
          id="Vector-8"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </svg>
);
